import axiosClient from "../apiClient";

export const getCurrentPlanDetails = async ({ id }: { id: string }) => {
  try {
    const response = await axiosClient.get(`/plan/details/${id}`);
    return response;
  } catch (error) {
    return error;
  }
};

export const getSession = async ({
  type,
  currency,
  subscriptionId,
  updateCard = false,
  isSeat = false,
  seatCount = 0,
}: {
  type: string;
  currency: string;
  subscriptionId: string;
  updateCard?: boolean;
  isSeat?: boolean;
  seatCount?: number;
}) => {
  try {
    const body: {
      paymentMethod: string;
      subscriptionId?: string;
      countryCode: string;
      currency: string;
      updateCard?: boolean;
      amount: number;
      isSeat?: boolean;
      seatCount?: number;
    } = {
      paymentMethod: type,
      subscriptionId: subscriptionId,
      countryCode: "NL",
      currency: currency,
      updateCard: updateCard,
      amount: 0,
      isSeat: isSeat,
      seatCount: seatCount,
    };
    if (isSeat) {
      delete body.updateCard;
      delete body.subscriptionId;
    } else {
      delete body.isSeat;
      delete body.seatCount;
    }

    const response = await axiosClient.post(
      `/payment/sessions?type=${type}`,
      body
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getPlaymentHistory = async () => {
  try {
    const response = await axiosClient.get(`/payment/list`);
    return response;
  } catch (error) {
    return error;
  }
};

export const getPlaymentLogs = async (data: { [key: string]: any }) => {
  try {
    const response = await axiosClient.post(`/payment/paymentLogs`, {
      ...data,
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const getPurchaseSeatLogs = async (data: { [key: string]: any }) => {
  try {
    const response = await axiosClient.post(`team/member/seat/memberSeatLogs`, {
      ...data,
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const getActiveSubscriptionDetails = async () => {
  try {
    const response = await axiosClient.get(`payment/activeSubscriptionDetails`);
    return response;
  } catch (error) {
    return error;
  }
};

export const getDownGradeSubscriptionPlan = async (data: {
  [key: string]: any;
}) => {
  try {
    const response = await axiosClient.post(
      `/payment/downGradeSubscriptionPlan`,
      { planId: data }
    );
    return response;
  } catch (error) {
    return error;
  }
};
export const getUserCardDetails = async () => {
  try {
    const response = await axiosClient.get(`/payment/getUserCardDetails`);
    return response;
  } catch (error) {
    return error;
  }
};

export const getPaymentDetails = async (id: string) => {
  try {
    const response = await axiosClient.get(`/payment/detail/${id}`);
    return response;
  } catch (error) {
    return error;
  }
};

export const cancelSubscription = async () => {
  try {
    const response = await axiosClient.get(`/payment/subscription-cancel`);
    return response;
  } catch (error) {
    return error;
  }
};

export const getPaymentMethods = async () => {
  try {
    const response = await axiosClient.get(`/payment/paymentMethods`, {
      params: { type: "scheme" },
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const handlePayment = async (data: { [key: string]: any }) => {
  try {
    const response = await axiosClient.post(`/payment/submit-payment`, {
      ...data,
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const paymentWithToken = async (data: { [key: string]: any }) => {
  try {
    const response = await axiosClient.post(`/payment/paymentWithToken`, {
      ...data,
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const paymentSeatWithTokenService = async (data: {
  [key: string]: any;
}) => {
  try {
    const response = await axiosClient.post(`payment/paymentSeatWithToken`, {
      ...data,
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const updatePaymentCardDetails = async (data: {
  [key: string]: any;
}) => {
  try {
    const response = await axiosClient.post(
      `/payment/updatePaymentCardDetails`,
      {
        ...data,
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const checkPaymentDone = async () => {
  try {
    const response = await axiosClient.get(`/payment/check-payment-done`);
    return response;
  } catch (error) {
    return error;
  }
};

export const setDefalutSaveCardService = async (cardId: string) => {
  try {
    const response = await axiosClient.post(
      `payment/setDefalutSaveCard/${cardId}`
    );
    return response;
  } catch (error) {
    return error;
  }
};
